import script from "./JustMadePayment.vue?vue&type=script&setup=true&lang=js"
export * from "./JustMadePayment.vue?vue&type=script&setup=true&lang=js"

import "./JustMadePayment.vue?vue&type=style&index=0&id=49f81286&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49f81286"]])

export default __exports__